module.exports = __webpack_public_path__ + "static/media/logo-white.e9834758.svg";